module.exports = __webpack_public_path__ + "assets/img/10.38e006ee.jpg";